/**
 * Оснащение
 */
import { EntityState } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class Equipment extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public id: number; /*Идентификатор БД*/
    public parent: number; /*Идентификатор родительской записи БД*/
    public entity_state: EntityState; /**/
    public code: string; /*Код*/
    public name: string; /*Наименование*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.id = json.id || null;
        this.parent = json.parent || null;
        this.entity_state = new EntityState(json.entity_state);
        this.code = json.code || null;
        this.name = json.name || null;
        this._isEmpty = this.isEmpty(this);
    }
}
